/*global _wa: false, YT: false*/
"use strict";
AndApp.customMoviePlayerForYT = {

  init() {
    const apiTag = document.createElement("script");
    apiTag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(apiTag, firstScriptTag);
  },

  youtubePlayerNormal: null,
  youtubeMovieNormal: document.querySelector("#js-topIntroductionMovie"),
  youtubePlayBtnNormal: document.querySelector("#js-topIntroductionMoviePlay"),
  youtubePosterNormal: document.querySelector("#js-topIntroductionMoviePoster"),
  setYoutubePlayerNormal() {
    const self = this;
    const youtubePlayerId = self.youtubeMovieNormal.getAttribute('id');
    self.youtubePlayerNormal = {
      player: null,
      setOption(videoId) {
        const options = {
          videoId,
          playerVars: {
            rel: 0,
            showinfo: 0,
            wmode: 'transparent',
          },
          events: {
            "onReady": this.onReady,
            "onStateChange": this.onStateChange
          }
        };
        return options;
      },
      onReady() {
        // youtubeのiframeとバッティング？するバグ対策として
        // playerのonReadyでtwitterのapiを呼び出す
        setTwitterWidgets();
      },
      onStateChange(event) {
        if (event.data === YT.PlayerState.PLAYING) {
          toggleButtonAndPoster("hidden", self);
        } else if (event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.CUED) {
          toggleButtonAndPoster("visibble", self);
        }
      },
      play(event) {
        this.player.playVideo();
      },
      setMovie(movieId) {
        self.youtubePosterNormal.setAttribute('src', `https://i.ytimg.com/vi/${  movieId  }/maxresdefault.jpg`);
        if (this.player) {
          this.player.cueVideoById(movieId);
        } else {
          this.player = new YT.Player(youtubePlayerId, this.setOption(movieId));
        }
        self.youtubePlayBtnNormal.addEventListener('click', function() {
          toggleButtonAndPoster("hidden", self);
          AndApp.customMoviePlayerForYT.youtubePlayerNormal.play();
        });
      }
    };
  }
};

function toggleButtonAndPoster(flag, scope) {
  const fl = flag;
  const sc = scope;
  const btn = sc.youtubePlayBtnNormal;
  const pos = sc.youtubePosterNormal;
  if (fl === "visibble") {
    btn.classList.remove('u-d-none');
    pos.classList.remove('is-hidden');
  }
  else if (fl === "hidden") {
    btn.classList.add('u-d-none');
    pos.classList.add('is-hidden');
  }
}

function setTwitterWidgets() {
  window.twttr = (function(d, s, id) {
    let js, fjs = d.getElementsByTagName(s)[0],
      t = window.twttr || {};
    if (d.getElementById(id)) { return t; }
    js = d.createElement(s);
    js.id = id;
    js.src = "https://platform.twitter.com/widgets.js";
    fjs.parentNode.insertBefore(js, fjs);

    t._e = [];
    t.ready = function(f) {
      t._e.push(f);
    };

    return t;
  }(document, "script", "twitter-wjs"));
}
